import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { Desktop } from "./desktop";

export const AppHeader = () => {
  return <ResponsiveBlockSwitcher mobile={<></>} desktop={<Desktop />} />;
};
